export interface Notification {
  id: number;
  type: "info" | "warning" | "success" | "error";
  title: string;
  message: string;
  createdAt: string;
  isRead: boolean;
  module: "documents" | "properties" | "payments" | "requests" | "system";
  link?: string;
  metadata?: {
    documentId?: number;
    documentName?: string;
    propertyId?: number;
    propertyName?: string;
    paymentId?: number;
    paymentAmount?: number;
    requestId?: number;
    userId?: number;
    userName?: string;
  };
}

export const mockNotifications: Notification[] = [
  {
    id: 1,
    type: "info",
    title: "Новий документ",
    message: "Додано новий документ 'Договір оренди.docx'",
    createdAt: "2024-03-15T10:00:00",
    isRead: false,
    module: "documents",
    metadata: {
      documentId: 1,
      documentName: "Договір оренди.docx"
    }
  },
  {
    id: 2,
    type: "warning",
    title: "Термін дії договору закінчується",
    message: "Договір оренди для квартири 'Сучасна квартира в центрі' закінчується через 7 днів",
    createdAt: "2024-03-14T15:30:00",
    isRead: false,
    module: "properties",
    metadata: {
      propertyId: 1,
      propertyName: "Сучасна квартира в центрі"
    }
  },
  {
    id: 3,
    type: "success",
    title: "Платіж отримано",
    message: "Отримано платіж на суму 15000 грн",
    createdAt: "2024-03-13T09:45:00",
    isRead: true,
    module: "payments",
    metadata: {
      paymentId: 1,
      paymentAmount: 15000
    }
  },
  {
    id: 4,
    type: "error",
    title: "Помилка завантаження",
    message: "Не вдалося завантажити документ 'Технічний паспорт.pdf'",
    createdAt: "2024-03-12T14:20:00",
    isRead: false,
    module: "documents",
    metadata: {
      documentId: 3,
      documentName: "Технічний паспорт.pdf"
    }
  },
  {
    id: 5,
    type: "info",
    title: "Новий запит",
    message: "Створено новий запит на ремонт",
    createdAt: "2024-03-11T11:15:00",
    isRead: true,
    module: "requests",
    metadata: {
      requestId: 1
    }
  },
  {
    id: 6,
    type: "warning",
    title: "Потрібна оплата",
    message: "Очікується оплата комунальних послуг",
    createdAt: "2024-03-10T16:40:00",
    isRead: false,
    module: "payments",
    metadata: {
      paymentId: 2,
      paymentAmount: 2500
    }
  },
  {
    id: 7,
    type: "success",
    title: "Документ підписано",
    message: "Документ 'Акт прийому-передачі.pdf' успішно підписано",
    createdAt: "2024-03-09T13:25:00",
    isRead: true,
    module: "documents",
    metadata: {
      documentId: 2,
      documentName: "Акт прийому-передачі.pdf"
    }
  },
  {
    id: 8,
    type: "info",
    title: "Новий орендар",
    message: "Додано нового орендаря до квартири",
    createdAt: "2024-03-08T09:30:00",
    isRead: false,
    module: "properties",
    metadata: {
      propertyId: 1,
      propertyName: "Сучасна квартира в центрі",
      userId: 2,
      userName: "Марія Коваленко"
    }
  },
  {
    id: 9,
    type: "warning",
    title: "Закінчується термін дії страховки",
    message: "Термін дії страхового полісу закінчується через 14 днів",
    createdAt: "2024-03-07T15:50:00",
    isRead: false,
    module: "documents",
    metadata: {
      documentId: 10,
      documentName: "Страховий поліс.pdf"
    }
  },
  {
    id: 10,
    type: "success",
    title: "Запит виконано",
    message: "Запит на ремонт успішно виконано",
    createdAt: "2024-03-06T10:15:00",
    isRead: true,
    module: "requests",
    metadata: {
      requestId: 1
    }
  },
  {
    id: 11,
    type: "info",
    title: "Оновлення системи",
    message: "Заплановано технічне обслуговування системи",
    createdAt: "2024-03-05T14:20:00",
    isRead: false,
    module: "system"
  },
  {
    id: 12,
    type: "error",
    title: "Помилка оплати",
    message: "Не вдалося обробити платіж",
    createdAt: "2024-03-04T16:30:00",
    isRead: false,
    module: "payments",
    metadata: {
      paymentId: 3,
      paymentAmount: 5000
    }
  },
  {
    id: 13,
    type: "success",
    title: "Документ оновлено",
    message: "Документ 'Договір на ремонт.docx' успішно оновлено",
    createdAt: "2024-03-03T11:45:00",
    isRead: true,
    module: "documents",
    metadata: {
      documentId: 8,
      documentName: "Договір на ремонт.docx"
    }
  },
  {
    id: 14,
    type: "warning",
    title: "Перевірка безпеки",
    message: "Виявлено спробу входу з нового пристрою",
    createdAt: "2024-03-02T09:20:00",
    isRead: false,
    module: "system"
  },
  {
    id: 15,
    type: "info",
    title: "Нове повідомлення",
    message: "Отримано нове повідомлення від орендаря",
    createdAt: "2024-03-01T13:10:00",
    isRead: false,
    module: "properties",
    metadata: {
      propertyId: 2,
      propertyName: "Комерційне приміщення",
      userId: 3,
      userName: "ТОВ 'Бізнес'"
    }
  }
]; 